var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalWrapper',{ref:"modal",attrs:{"title":_vm.title,"ok-title":_vm.okTitle,"ok-variant":_vm.okVariant}},[_c('p',{staticClass:"mt-3 mb-3"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }